export default "__VITE_ASSET__BywGkJil__"